function menuToggle(containerSelector, buttonSelector, openClass = "open") {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const toggleButton = container.querySelector(buttonSelector);
  if (!toggleButton) return;

  toggleButton.addEventListener("click", () => {
    container.classList.toggle(openClass);
  });

  return {
    open: () => container.classList.add(openClass),
    close: () => container.classList.remove(openClass),
    toggle: () => container.classList.toggle(openClass),
  };
}
